import { useForm } from '@mantine/form';

export interface SubmitChecklistFormValues {
  items: { checklistItemId: string; isChecked: boolean }[];
  durationMinutes: number | '';
  globalComment: string;
}

export const useSubmitChecklistForm = () => {
  const form = useForm<SubmitChecklistFormValues>({
    initialValues: {
      items: [],
      durationMinutes: '',
      globalComment: '',
    },
    validate: {
      globalComment: value =>
        value.length > 500 ? 'Le commentaire ne peut pas dépasser 500 caractères' : null,
    },
  });

  return form;
};
